import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createSec17InterimOrdersAPI,
  updateSec17InterimOrdersAPI,
  getSec17InterimOrdersByCaseIDAPI,
  deleteSec17InterimOrdersAPI,
  createSec17RevocationRequestAPI,
  updateSec17RevocationRequestAPI,
  getSec17RevocationRequestByCaseIDAPI,
  deleteSec17RevocationRequestAPI,
  deleteSec17RevocationRequestDocumentAPI,
} from "../../../api/Sec17InterimOrders_api";

export const getSec17InterimOrdersByCaseIDAction = createAsyncThunk(
  "sec17InterimOrders/getSec17InterimOrdersByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getSec17InterimOrdersByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createSec17InterimOrdersAction = createAsyncThunk(
  "sec17InterimOrders/createSec17InterimOrders",
  async (arbitratorDetailsData, { rejectWithValue }) => {
    const response = await createSec17InterimOrdersAPI(arbitratorDetailsData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateSec17InterimOrdersAction = createAsyncThunk(
  "sec17InterimOrders/updateSec17InterimOrdersAPI",
  async (
    { sec17InterimOrders_ID, sec17InterimOrdersData },
    { rejectWithValue },
  ) => {
    const response = await updateSec17InterimOrdersAPI(
      sec17InterimOrders_ID,
      sec17InterimOrdersData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteSec17InterimOrdersAction = createAsyncThunk(
  "sec17InterimOrders/deleteSec17InterimOrders",
  async (sec17InterimOrders_ID, { rejectWithValue }) => {
    const response = await deleteSec17InterimOrdersAPI(sec17InterimOrders_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const getSec17RevocationRequestByCaseIDAction = createAsyncThunk(
  "sec17InterimOrders/getSec17RevocationRequestByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getSec17RevocationRequestByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createSec17RevocationRequestAction = createAsyncThunk(
  "sec17InterimOrders/createClaimantAdministrator",
  async (sec17RevocationRequestData, { rejectWithValue }) => {
    const response = await createSec17RevocationRequestAPI(
      sec17RevocationRequestData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateSec17RevocationRequestAction = createAsyncThunk(
  "sec17InterimOrders/updateSec17RevocationRequest",
  async (
    { sec17RevocationRequest_ID, sec17RevocationRequestData },
    { rejectWithValue },
  ) => {
    const response = await updateSec17RevocationRequestAPI(
      sec17RevocationRequest_ID,
      sec17RevocationRequestData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteSec17RevocationRequestAction = createAsyncThunk(
  "sec17InterimOrders/deleteSec17RevocationRequest",
  async (sec17RevocationRequest_ID, { rejectWithValue }) => {
    const response = await deleteSec17RevocationRequestAPI(
      sec17RevocationRequest_ID,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteSec17RevocationRequestDocumentAction = createAsyncThunk(
  "sec17InterimOrders/deleteSec17RevocationRequestDocument",
  async ({ documentID }, { rejectWithValue }) => {
    const response = await deleteSec17RevocationRequestDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
